import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name totalCards
 * @description Calculate total number of rate cards present in FCL/LCL/AIR json. Only one type can be non-empty at a time.
 * <br><br>
 * e.g If FCL json is non-empty, then LCL and AIR type JSON's willl be empty.
 *
 * @param {Object} seaFCLJSON - FCL rate json
 * @param {Object} seaLCLJSON - LCL rate json
 * @param {Object} airJSON    - AIR rate json
 * @returns {number}
 *
 * @example
 * console.log(totalCards(
 * {...,rates: {fcl: [{id: 12,...}, {id: 15,...}] }, ...},
 * {},
 * {}
 * )); //2
 */
export const totalCards = (seaFCLJSON, seaLCLJSON, airJSON) => {
  const totalCards =
    cardNumbers(seaFCLJSON, 'fcl') ||
    cardNumbers(seaLCLJSON, 'lcl') ||
    cardNumbers(airJSON, 'air') ||
    0;
  return totalCards;
};

const cardNumbers = (rateJSON, type) => {
  return (
    (rateJSON &&
      !isEmpty(rateJSON) &&
      rateJSON.rates &&
      Array.isArray(rateJSON.rates[type]) &&
      rateJSON.rates[type].length) ||
    0
  );
};
